export default {
  lang_name: 'Deutsch',
  tab_main: 'Haupt', tab_upgrade: 'Upgrade', tab_prestige: 'Prestige', tab_achievement: 'Erfolge', tab_mission: 'Mission', tab_domination: 'Welt', tab_settings: 'Einst.',
  hud_cps: '/s', hud_boost: 'Boost',
  main_tap_area: 'TIPPEN!', main_combo: 'Kombo',
  prod_informant: 'Informant', prod_informant_desc: 'Informationsbeschaffung',
  prod_hacker: 'Hacker', prod_hacker_desc: 'Netzwerk-Infiltration',
  prod_disguiser: 'Verkleidung', prod_disguiser_desc: 'Menschliche Tarnung',
  prod_mindController: 'Gedankenkontrolle', prod_mindController_desc: 'Meinungsmanipulation',
  prod_secretLab: 'Geheimlabor', prod_secretLab_desc: 'Reptilien-Technologie',
  prod_mediaCell: 'Medienzelle', prod_mediaCell_desc: 'Nachrichtensteuerung',
  prod_shadowGovt: 'Schattenregierung', prod_shadowGovt_desc: 'Politikerersatz',
  prod_deepBase: 'Tiefe Basis', prod_deepBase_desc: 'Untergrund-Megabasis',
  prod_orbitalStation: 'Orbitalstation', prod_orbitalStation_desc: 'Satellitenüberwachung',
  prod_dimensionGate: 'Dimensionstor', prod_dimensionGate_desc: 'Heimatwelt-Verstärkung',
  prod_planetController: 'Planetenkontrolle', prod_planetController_desc: 'Erdkontrolle',
  prod_galacticBeacon: 'Galaktischer Sender', prod_galacticBeacon_desc: 'Direktleitung zum HQ',
  prod_locked: 'Freischalten: ', prod_locked_prestige: 'Prestige {n}x', prod_locked_time: '{n}min Spiel',
  milestone_squad: 'Trupp', milestone_company: 'Kompanie', milestone_battalion: 'Bataillon',
  milestone_regiment: 'Regiment', milestone_division: 'Division', milestone_corps: 'Korps',
  click_basic_training: 'Grundausbildung', click_combat_training: 'Kampftraining',
  click_psychic_awaken: 'Psychisches Erwachen', click_transform: 'Transformation',
  click_telepathy: 'Telepathie', click_critical_eye: 'Kritisches Auge',
  click_dimension_sense: 'Dimensionssinn', click_galaxy_field: 'Galaxiefeld',
  click_lethal_strike: 'Tödlicher Schlag', click_absolute: 'Absolute Infiltration',
  click_planet_destroyer: 'Planetenzerstörer', click_galaxy_finger: 'Finger des Overlords',
  special_info_network: 'Info-Netzwerk', special_info_network_desc: 'Informant & Hacker x2',
  special_perfect_disguise: 'Perfekte Tarnung', special_perfect_disguise_desc: 'Alle Agenten x1.5',
  special_mass_brainwash: 'Massengehirnwäsche', special_mass_brainwash_desc: 'Gedankenkontrolle & Medien x3',
  special_shadow_network: 'Schattennetzwerk', special_shadow_network_desc: 'Offline-Einkommen +25%',
  special_underground_empire: 'Untergrundimperium', special_underground_empire_desc: 'Alle Agenten x2',
  special_orbital_surveillance: 'Orbitalüberwachung', special_orbital_surveillance_desc: 'Goldene Events +50%',
  special_dimension_supply: 'Dimensionsversorgung', special_dimension_supply_desc: 'Tipp-Einkommen x5',
  special_galactic_alliance: 'Galaktische Allianz', special_galactic_alliance_desc: '🛸 pro Sekunde x10',
  special_combo_master: 'Kombo-Meister', special_combo_master_desc: 'Kombo-Limit x3',
  special_time_warp: 'Zeitsprung', special_time_warp_desc: 'Offline-Limit 12h',
  special_agent_synergy: 'Agentensynergie', special_agent_synergy_desc: '🛸 pro Sekunde x1.5',
  special_massive_infiltration: 'Masseninfiltration', special_massive_infiltration_desc: '🛸 pro Sekunde x2',
  subtab_click: 'Klick', subtab_special: 'Spezial',
  prestige_title: 'Umstrukturierung', prestige_total_ip: 'Gesamt-🛸', prestige_gc_gain: '💎-Gewinn',
  prestige_gc_current: 'Aktuelle 💎', prestige_execute: 'Umstrukturieren',
  prestige_confirm: 'Fortschritt zurücksetzen für {gc} Galaktische Credits?',
  prestige_ad_bonus: 'Werbung für +50% 💎', prestige_requirement: '10B+ 🛸 für Prestige nötig',
  prestige2_title: 'Galaxie-Umstrukturierung', prestige2_cores_gain: '🔮 erhalten',
  prestige2_cores_current: 'Aktuelle 🔮', prestige2_execute: 'Galaxie-Umstrukturierung',
  prestige2_requirement: '15+ Prestiges & 100+ 💎 nötig',
  prestige2_confirm: 'Alles zurücksetzen für {cores} Galaxie-Kerne?',
  pup_galaxy_mult: 'Galaxie-Multiplikator', pup_galaxy_mult_desc: 'CPS x1.5 pro Level (multiplikativ stapelbar)',
  pup_infil_accel: 'Infiltrations-Beschleunigung', pup_infil_accel_desc: 'Nach Prestige pro Level mit 100M 🛸 starten',
  pup_tap_enhance: 'Tipp-Verstärkung', pup_tap_enhance_desc: 'Tipp-Einkommen x2 pro Level (multiplikativ stapelbar)',
  pup_offline_expand: 'Offline-Erweiterung', pup_offline_expand_desc: 'Offline-Belohnungs-Limit +1h/Lv (Basis 8h)',
  pup_offline_eff: 'Offline-Effizienz', pup_offline_eff_desc: 'Offline-Einkommensrate +10%p/Lv (Basis 50%)',
  pup_agent_discount: 'Agentenrabatt', pup_agent_discount_desc: 'Agenten-Einstellungskosten -10% pro Level (max -50%)',
  pup_auto_click: 'Auto-Klick', pup_auto_click_desc: 'Auto-Tipp 3x/Sek pro Level (max 15/Sek)',
  pup_golden_luck: 'Goldenes Glück', pup_golden_luck_desc: 'Goldenes Event Belohnung +20%/Lv (max +200%)',
  pup_combo_keep: 'Kombo-Erhalt', pup_combo_keep_desc: 'Combo-Timer +0.5s/Lv (Basis 2s)',
  pup_quick_start: 'Schnellstart', pup_quick_start_desc: 'Nach Prestige je 1 der ersten 5 Agenten automatisch erhalten',
  p2up_galaxy_speed: 'Galaxie-Geschwindigkeit', p2up_galaxy_speed_desc: '💎-Gewinn x2 pro Level bei Prestige (multiplikativ)',
  p2up_auto_prestige: 'Auto-Prestige', p2up_auto_prestige_desc: 'Automatisches Prestige bei 10Mrd 🛸',
  p2up_permanent: 'Permanente Agenten', p2up_permanent_desc: 'Erste 3 Agententypen nach Prestige behalten',
  p2up_dimension_accel: 'Dimensions-Beschleunigung', p2up_dimension_accel_desc: 'CPS x5 pro Level (stapelbar, permanent)',
  p2up_galaxy_memory: 'Galaxie-Gedächtnis', p2up_galaxy_memory_desc: '3 aktive Boosts durch Prestige behalten',
  p2up_spacetime: 'Raumzeitkrümmung', p2up_spacetime_desc: 'Offline-Einkommensrate auf 100% setzen (permanent)',
  p2up_automate: 'Galaxie-Automatisierung', p2up_automate_desc: 'Agenten automatisch einstellen (permanent)',
  rank_e: 'Praktikant', rank_d: 'Junior-Agent', rank_c: 'Agent', rank_b: 'Senior-Agent',
  rank_a: 'Direktor', rank_s: 'Kommandant', rank_ss: 'Oberbefehlshaber', rank_sss: 'Galaktischer Overlord',
  ach_title: 'Erfolge', ach_filter_all: 'Alle', ach_filter_tap: 'Tippen', ach_filter_resource: 'Ressource',
  ach_filter_producer: 'Produzent', ach_filter_prestige: 'Prestige', ach_filter_time: 'Zeit',
  ach_filter_special: 'Spezial', ach_filter_ad: 'Dokumente', ach_filter_combo: 'Kombo',
  ach_t01: 'Erster Schritt', ach_t01_reward: '+1 Tippkraft', ach_t02: 'Fingerübung', ach_t02_reward: '+5% Tippkraft',
  ach_t03: 'Beständiger Agent', ach_t03_reward: '+10% Tippkraft', ach_t04: 'Touch-Meister', ach_t04_reward: '+15% Tippkraft',
  ach_t05: 'Reptilischer Biss', ach_t05_reward: '+20% Tippkraft', ach_t06: 'Galaxiefinger', ach_t06_reward: '+25% Tippkraft',
  ach_t07: 'Kombo-Lehrling', ach_t07_reward: '+0.5s Kombo', ach_t08: 'Kombo-Meister', ach_t08_reward: '+0.5 Kombo-Limit',
  ach_r01: 'Kleine Info', ach_r01_reward: '+5% \u{1F6F8}/s', ach_r02: 'Info-Sammler', ach_r02_reward: '+5% \u{1F6F8}/s',
  ach_r03: 'Geheimtresor', ach_r03_reward: '+5% \u{1F6F8}/s', ach_r04: 'Millionen-Infiltration', ach_r04_reward: '+10% \u{1F6F8}/s',
  ach_r05: 'Milliarden-Agent', ach_r05_reward: '+10% \u{1F6F8}/s', ach_r06: 'Billionen-Ops', ach_r06_reward: '+15% \u{1F6F8}/s',
  ach_r07: 'Billiarden-Imperium', ach_r07_reward: '+15% \u{1F6F8}/s', ach_r08: 'Galaxie-Ozean', ach_r08_reward: '+20% \u{1F6F8}/s',
  ach_r09: 'Kosmisches Universum', ach_r09_reward: '+20% \u{1F6F8}/s', ach_r10: 'Unendliche Infiltration', ach_r10_reward: '+30% \u{1F6F8}/s',
  ach_g01: 'Erste Rekrutierung', ach_g01_reward: 'Informant x1.5', ach_g02: 'Intel-Netzwerk', ach_g02_reward: 'Informant x2',
  ach_g03: 'Hacking beginnt', ach_g03_reward: 'Hacker x2', ach_g04: 'Cyber-Legion', ach_g04_reward: 'Hacker x3',
  ach_g05: 'Meister der Tarnung', ach_g05_reward: 'Verkleidung x2', ach_g06: 'Gehirnwäsche-Netz', ach_g06_reward: 'Gedankenkontrolle x2',
  ach_g07: 'Verrückte Wissenschaft', ach_g07_reward: 'Geheimlabor x2', ach_g08: 'Medienkontrolle', ach_g08_reward: 'Medienzelle x2',
  ach_g09: 'Schattenkabinett', ach_g09_reward: 'Schattenregierung x2', ach_g10: 'Untergrundimperium', ach_g10_reward: 'Tiefe Basis x2',
  ach_g11: 'Orbitale Dominanz', ach_g11_reward: 'Orbitalstation x2', ach_g12: 'Meister der Galaxie', ach_g12_reward: 'Gesamt \u{1F6F8}/s x2',
  ach_p01: 'Erste Umstrukturierung', ach_p01_reward: '+5 💎 Bonus', ach_p02: 'Geschmack des Zyklus', ach_p02_reward: '+10% 💎',
  ach_p03: 'Veteran', ach_p03_reward: '+10% 💎', ach_p04: 'Prestige-Süchtiger', ach_p04_reward: '+15% 💎',
  ach_p05: 'Endlosschleife', ach_p05_reward: '+20% 💎', ach_p06: 'Galaxie-Gedächtnis', ach_p06_reward: '+25% 💎',
  ach_p07: 'Galaxie-Umstrukturierung', ach_p07_reward: '+3 🔮 Bonus', ach_p08: 'Dimensionsherrscher', ach_p08_reward: '+20% 🔮',
  ach_h01: 'Neuling', ach_h01_reward: 'Willkommensbonus 100 🛸', ach_h02: '1-Stunden-Schicht', ach_h02_reward: '+5% \u{1F6F8}/s',
  ach_h03: 'Halber Tag', ach_h03_reward: '+10% \u{1F6F8}/s', ach_h04: '24h Überwachung', ach_h04_reward: 'Offline +2h',
  ach_h05: '3-Tage-Mission', ach_h05_reward: '\u{1F6F8}/s x1.5', ach_h06: 'Wocheninfiltration', ach_h06_reward: '\u{1F6F8}/s x2',
  ach_s01: 'Verdächtiger Mensch', ach_s01_reward: '1 Dok', ach_s02: 'Neustart', ach_s02_reward: 'Titel: Waghalsiger Agent',
  ach_s03: 'Alles rein', ach_s03_reward: '+10% \u{1F6F8}/s', ach_s04: 'Speed Run', ach_s04_reward: '+10 💎 Bonus',
  ach_s05: 'Goldjäger', ach_s05_reward: 'Event-Frequenz -20%', ach_s06: 'Nachtagent', ach_s06_reward: 'Nacht \u{1F6F8}/s x1.5',
  ach_s07: 'F2P-Krieger', ach_s07_reward: 'Werbebelohnung +30%', ach_s08: 'Sammler', ach_s08_reward: '\u{1F6F8}/s x3',
  ach_a01: 'Werbeanfänger', ach_a01_reward: '1 Dok', ach_a02: 'Werbebegeistert', ach_a02_reward: '2 Doks',
  ach_a03: 'Werbemeister', ach_a03_reward: 'Werbebelohnung +30%', ach_a04: 'Dok-Sammler', ach_a04_reward: 'Dok-Effekt +20%',
  ach_a05: 'Dok-Experte', ach_a05_reward: 'Dok-Effekt +50%',
  ach_c01: 'Kombo-Start', ach_c01_reward: '+0.3s Kombo', ach_c02: 'Im Rhythmus', ach_c02_reward: '+0.1 Kombo-Mult',
  ach_c03: 'Goldener Anfänger', ach_c03_reward: 'Event-Belohnung +10%', ach_c04: 'Goldener Sammler', ach_c04_reward: 'Event-Frequenz -10%',
  ach_c05: 'Täglicher Wahnsinn', ach_c05_reward: 'Missionsbelohnung +50%',
  golden_intel_leak: 'Info-Leak!', golden_agent_frenzy: 'Agenten-Rausch!', golden_money_launder: 'Geldwäsche!',
  golden_facility_boost: 'Anlagen-Overdrive!', golden_supply_drop: 'Galaxie-Lieferung!', golden_touch: 'TIPPEN!',
  golden_ad_double: 'Werbung für 2x',
  offline_title: 'Abwesenheitsbericht', offline_elapsed: 'Vergangene Zeit', offline_earned: 'Verdiente 🛸',
  offline_cap: 'Max {h}h angewendet', offline_claim: 'Einsammeln', offline_double: 'Werbung für 2x ({amount})',
  offline_hours: '{h}h {m}m',
  settings_title: 'Einstellungen', settings_bgm: 'BGM', settings_sfx: 'SFX', settings_lang: 'Sprache',
  settings_reset: 'Spiel zurücksetzen', settings_reset_confirm: 'ALLEN Fortschritt löschen?',
  settings_stats: 'Statistiken', settings_total_ip: 'Gesamt-🛸', settings_total_taps: 'Gesamt-Tipps',
  settings_total_prestiges: 'Gesamt-Prestiges', settings_play_time: 'Gesamtspielzeit', settings_docs_shop: 'Geheimakten-Shop',
  doc_shop_title: 'Geheimakten-Shop',
  doc_ip_boost: 'Einkommens-Beschleuniger', doc_ip_boost_desc: '2x 🛸/s Produktion fur 30 Sek',
  doc_mega_tap: 'Power-Tipp-Training', doc_mega_tap_desc: '3x Tipp-Einkommen fur 30 Sek',
  doc_auto_click: 'Auto-Infiltrator', doc_auto_click_desc: 'Auto-Tipp 10x/Sek fur 30 Sek',
  doc_instant_golden: 'Goldener Notruf', doc_instant_golden_desc: 'Goldenes Event sofort auslosen',
  doc_timeskip: 'Zeitbeschleuniger', doc_timeskip_desc: '2 Std 🛸-Einkommen sofort erhalten',
  doc_prestige_boost: 'Galaxis-Verstarker', doc_prestige_boost_desc: '2x 💎 beim nachsten Prestige',
  doc_prestige_boost_active: '💎 x2 wartet auf nachstes Prestige', doc_prestige_boost_active_badge: '✅ Aktiv',
  ad_offline_double: 'Doppelte Offline-Belohnung', ad_cps_boost: 'Einkommen/s x10 Boost (15s)',
  ad_prestige_bonus: 'Prestige +50% 💎', ad_timeskip: 'Zeitsprung (2h)', ad_free_docs: 'Gratis Geheimakten',
  ad_golden_double: 'Doppelte goldene Belohnung', ad_start_boost: 'Startboost-Paket',
  ad_watching: 'Werbung wird geladen...', ad_cooldown: 'Verfügbar in {t}',
  settings_sfx_test: 'SFX testen', settings_sound_reset: 'Zurücksetzen', settings_sound_reset_done: 'Sound zurückgesetzt',
  num_k: 'K', num_m: 'M', num_b: 'Mrd', num_t: 'Bio', num_qa: 'Brd', num_qi: 'Tri', num_sx: 'Sx', num_sp: 'Sp', num_oc: 'Oc', num_no: 'No', num_dc: 'Dc',
  mission_title: 'Tagesmissionen',
  mission_claim: 'Abholen',
  mission_all_complete: 'Alle abgeschlossen Bonus!',
  mission_clear_label: 'MISSION',
  mission_all_clear_label: 'ALLE KLAR',
  ach_unlock_label: 'ERFOLG',
  mission_diff_easy: 'Leicht',
  mission_diff_normal: 'Mittel',
  mission_diff_hard: 'Schwer',
  mission_tap_100: 'Leichte Berührung', mission_tap_100_desc: '100 Mal tippen',
  mission_tap_300: 'Warme Hände', mission_tap_300_desc: '300 Mal tippen',
  mission_buy_5: 'Kleine Rekrutierung', mission_buy_5_desc: '5 Produzenten kaufen',
  mission_combo_10: 'Kombo-Starter', mission_combo_10_desc: '10 Kombo erreichen',
  mission_golden_1: 'Glücksfang', mission_golden_1_desc: '1 goldenes Event fangen',
  mission_tap_1000: 'Harter Schlag', mission_tap_1000_desc: '1.000 Mal tippen',
  mission_buy_20: 'Truppaufbau', mission_buy_20_desc: '20 Produzenten kaufen',
  mission_combo_50: 'Kombo-Profi', mission_combo_50_desc: '50 Kombo erreichen',
  mission_golden_3: 'Goldrausch', mission_golden_3_desc: '3 goldene Events fangen',
  mission_earn_1m: 'Millionen-Ops', mission_earn_1m_desc: '1M 🛸 verdienen',
  mission_tap_5000: 'Tipp-Maschine', mission_tap_5000_desc: '5.000 Mal tippen',
  mission_buy_50: 'Armee-Aufbau', mission_buy_50_desc: '50 Produzenten kaufen',
  mission_combo_100: 'Kombo-Gott', mission_combo_100_desc: '100 Kombo erreichen',
  mission_golden_5: 'Goldener Meister', mission_golden_5_desc: '5 goldene Events fangen',
  mission_earn_1b: 'Milliarden-Agent', mission_earn_1b_desc: '1Mrd 🛸 verdienen',
  mission_tap_200: 'Schnelle Finger',
  mission_tap_200_desc: '200 Mal tippen',
  mission_buy_3: 'Erste Rekruten',
  mission_buy_3_desc: '3 Produzenten kaufen',
  mission_combo_15: 'Combo-Anfänger',
  mission_combo_15_desc: '15er Combo erreichen',
  mission_earn_10k: 'Taschengeld',
  mission_earn_10k_desc: '10K 🛸 verdienen',
  mission_earn_100k: 'Spendensammler',
  mission_earn_100k_desc: '100K 🛸 verdienen',
  mission_tap_500: 'Beständiger Tipper',
  mission_tap_500_desc: '500 Mal tippen',
  mission_tap_700: 'Unerbittlich',
  mission_tap_700_desc: '700 Mal tippen',
  mission_buy_10: 'Teamleiter',
  mission_buy_10_desc: '10 Produzenten kaufen',
  mission_combo_30: 'Combo-Kette',
  mission_combo_30_desc: '30er Combo erreichen',
  mission_golden_2: 'Doppelgold',
  mission_golden_2_desc: '2 goldene Events fangen',
  mission_tap_3000: 'Tipp-Krieger',
  mission_tap_3000_desc: '3.000 Mal tippen',
  mission_buy_30: 'Bataillon',
  mission_buy_30_desc: '30 Produzenten kaufen',
  mission_combo_75: 'Combo-Elite',
  mission_combo_75_desc: '75er Combo erreichen',
  mission_golden_4: 'Goldjäger',
  mission_golden_4_desc: '4 goldene Events fangen',
  mission_earn_10m: 'Tycoon',
  mission_earn_10m_desc: '10M 🛸 verdienen',
  // Conquest
  cq_title: 'Welteroberung',
  cq_progress: 'Erobert',
  cq_infiltration_power: 'Infiltrationskraft',
  cq_active_conquest: 'Infiltriert',
  cq_infiltration_progress: 'Infiltrationsfortschritt',
  cq_time_remaining: 'Geschätzte Zeit',
  cq_start_infiltration: 'Infiltration starten',
  cq_stop_infiltration: 'Infiltration stoppen',
  cq_no_power_hint: 'Stellen Sie Agenten ein, um Infiltrationskraft zu erzeugen',
  cq_locked: 'Gesperrt',
  cq_available: 'Verfügbar',
  cq_conquered: 'Erobert',
  cq_popup_title: 'Eroberung abgeschlossen!',
  cq_popup_desc: 'wurde erobert! Baue Einrichtungen, um stärker zu werden.',
  cq_back: 'Zurück',
  cq_invest_title: '🛸 investieren um zu erobern',
  cq_current_ip: 'Aktuell 🛸',
  cq_facilities: 'Einrichtungen',
  cq_build: 'Bauen',
  cq_upgrade: 'Verbessern',
  cq_next_level: 'Nächste',
  cq_counter_intel_title: 'Spionageabwehr-Alarm!',
  cq_counter_intel_text: 'Ihre Infiltration in {country} wurde entdeckt! Fortschritt wird reduziert.',
  cq_defend_ad: 'Werbung sehen & verteidigen',
  cq_accept_loss: 'Verlust akzeptieren',
  cq_ending_title: 'Erde erobert!',
  cq_ending_text: 'Die Reptilien-Verschwörung ist vollständig. Alle Nationen beugen sich dem Schattenreich.',
  cq_ending_time: 'Spielzeit',
  cq_ending_prestiges: 'Prestiges',
  cq_ending_total_ip: 'Gesamt-🛸',
  cq_ending_taps: 'Gesamt-Taps',
  cq_ending_continue: 'Weiterspielen',
  cq_egypt: 'Ägypten', cq_egypt_desc: 'Antike Pyramidenbasen',
  cq_brazil: 'Brasilien', cq_brazil_desc: 'Amazonas-Dschungelverstecke',
  cq_india: 'Indien', cq_india_desc: 'Naga-Kult-Infiltration',
  cq_australia: 'Australien', cq_australia_desc: 'Wüsten-Untergrundbunker',
  cq_japan: 'Japan', cq_japan_desc: 'Technologie-Diebstahl',
  cq_korea: 'Korea', cq_korea_desc: 'NIS Cyber-Abwehr-Durchbruch',
  cq_uk: 'Vereinigtes Königreich', cq_uk_desc: 'MI5/MI6 Königliche Infiltration',
  cq_russia: 'Russland', cq_russia_desc: 'FSB Sibirische Operationen',
  cq_china: 'China', cq_china_desc: 'Stärkste Überwachung der Welt',
  cq_usa: 'Vereinigte Staaten', cq_usa_desc: 'CIA/NSA Endboss',
  fac_pyramid_vault: 'Pyramiden-Tresor', fac_pyramid_vault_d: '\u{1F6F8}/s +5% pro Level',
  fac_nile_network: 'Nil-Netzwerk', fac_nile_network_d: 'Offline +5% pro Level',
  fac_ancient_lab: 'Antikes Labor', fac_ancient_lab_d: 'TAP +10% pro Level',
  fac_amazon_hideout: 'Amazonas-Versteck', fac_amazon_hideout_d: 'Produzenten-Rabatt +2% pro Level',
  fac_samba_broadcast: 'Samba-Sender', fac_samba_broadcast_d: '\u{1F6F8}/s +8% pro Level',
  fac_jungle_lab: 'Dschungel-Labor', fac_jungle_lab_d: 'Golden Event +5% pro Level',
  fac_naga_temple: 'Naga-Tempel', fac_naga_temple_d: '💎 +5% pro Level',
  fac_bollywood_studio: 'Bollywood-Studio', fac_bollywood_studio_d: 'Offline +8% pro Level',
  fac_caste_network: 'Kasten-Netzwerk', fac_caste_network_d: '\u{1F6F8}/s +12% pro Level',
  fac_desert_bunker: 'Wüsten-Bunker', fac_desert_bunker_d: 'TAP +15% pro Level',
  fac_ayers_signal: 'Ayers-Signal', fac_ayers_signal_d: 'Golden Event +8% pro Level',
  fac_outback_base: 'Outback-Basis', fac_outback_base_d: '\u{1F6F8}/s +15% pro Level',
  fac_akiba_ai: 'Akihabara-KI', fac_akiba_ai_d: '\u{1F6F8}/s +20% pro Level',
  fac_ninja_intel: 'Ninja-Nachricht', fac_ninja_intel_d: 'Produzenten-Rabatt +3% pro Level',
  fac_tokyo_tower: 'Tokio-Turm', fac_tokyo_tower_d: '💎 +8% pro Level',
  fac_gangnam_hq: 'Gangnam-HQ', fac_gangnam_hq_d: '\u{1F6F8}/s +25% pro Level',
  fac_cyber_command: 'Cyber-Kommando', fac_cyber_command_d: 'TAP +25% pro Level',
  fac_kpop_brainwash: 'K-Pop Gehirnwäsche', fac_kpop_brainwash_d: '💎 +10% pro Level',
  fac_royal_infiltrate: 'Königliche Infiltration', fac_royal_infiltrate_d: '\u{1F6F8}/s +30% pro Level',
  fac_london_tower: 'London Tower', fac_london_tower_d: 'Offline +15% pro Level',
  fac_mi6_double: 'MI6 Doppelagent', fac_mi6_double_d: 'Golden Event +12% pro Level',
  fac_siberia_base: 'Sibirien-Basis', fac_siberia_base_d: '\u{1F6F8}/s +40% pro Level',
  fac_kgb_remnant: 'KGB-Überbleibsel', fac_kgb_remnant_d: 'Produzenten-Rabatt +5% pro Level',
  fac_nuke_bunker: 'Atom-Bunker', fac_nuke_bunker_d: 'TAP +40% pro Level',
  fac_great_wall: 'Große Firewall', fac_great_wall_d: '\u{1F6F8}/s +50% pro Level',
  fac_shenzhen_factory: 'Shenzhen-Fabrik', fac_shenzhen_factory_d: 'Produzenten-Rabatt +8% pro Level',
  fac_panda_spy: 'Panda-Spionagering', fac_panda_spy_d: 'Golden Event +20% pro Level',
  fac_area51: 'Area 51', fac_area51_d: '\u{1F6F8}/s +80% pro Level',
  fac_pentagon: 'Pentagon', fac_pentagon_d: 'TAP +80% pro Level',
  fac_wall_street: 'Wall Street', fac_wall_street_d: '💎 +25% pro Level',

  buy: 'Kaufen', max: 'MAX', level: 'Lv.', locked: 'Gesperrt', unlocked: 'Freigeschaltet',
  upgrade_locked_prev: 'Vorheriges Upgrade zuerst erlernen',
  condition: 'Bedingung', cost: 'Kosten', owned: 'Besitz', effect: 'Effekt', reward: 'Belohnung',
  close: 'Schließen', confirm: 'Bestätigen', cancel: 'Abbrechen',

  // Conquest achievements
  ach_filter_conquest: 'Eroberung',
  ach_q01: 'Erste Eroberung', ach_q01_reward: '\u{1F6F8}/s +10%',
  ach_q02: 'Dreifache Bedrohung', ach_q02_reward: 'TAP +10%',
  ach_q03: 'Halbe Welt', ach_q03_reward: '💎 +15%',
  ach_q04: 'Sieben Flaggen', ach_q04_reward: 'Offline +20%',
  ach_q05: 'Weltherrscher', ach_q05_reward: '\u{1F6F8}/s x3',
  ach_q06: 'Anlagenmeister', ach_q06_reward: '\u{1F6F8}/s x2',
  milestone_next: 'Nächstes',
  settings_conquest: 'Eroberung',

  // Currency info
  currency_ip_name: 'Infiltrationspunkte (IP)',
  currency_ip_earn: 'Durch Tippen, Auto-Produktion, Offline-Einkommen und Werbung',
  currency_ip_use: 'Agenten anheuern, Upgrades kaufen, in Eroberung investieren',
  currency_gc_name: 'Galaktische Credits (GC)',
  currency_gc_earn: 'Beim Prestige (Reorganisation) basierend auf Gesamt-IP',
  currency_gc_use: 'Prestige-Upgrades kaufen (Produktionsmultiplikator, Offline-Effizienz usw.)',
  currency_cores_name: 'Galaxie-Kerne',
  currency_cores_earn: 'Beim 2. Prestige (Galaxie-Reorganisation) basierend auf Gesamt-GC',
  currency_cores_use: '2. Prestige-Upgrades kaufen (permanente Buffs, Automatisierung usw.)',
  currency_docs_name: 'Geheimdokumente',
  currency_docs_earn: 'Tägliche Missionen, Werbung ansehen oder Erfolge freischalten',
  currency_docs_use: 'Im Dokument-Shop (Missions-Tab) starke Boosts kaufen',
  currency_how_earn: 'Wie verdienen',
  currency_how_use: 'Verwendung',

  // Prestige upgrades - conquest
  pup_infiltration_mastery: 'Infiltrationsmeister',
  pup_infiltration_mastery_desc: 'Gesamt-Infiltrationskraft +50%/Lv (max +500%)',
  pup_agent_network: 'Agentennetzwerk',
  pup_agent_network_desc: 'Pro 100 Agenten Infiltration +5% pro Level',
  pup_quick_infiltration: 'Ketteninfiltration',
  pup_quick_infiltration_desc: 'Bei Eroberung: nächstes Land +10% Fortschritt/Lv',
  pup_critical_chance: 'Kritisches Training',
  pup_critical_chance_desc: 'Tipp-Krit-Chance +3%/Lv (Basis 10%, max 50%)',
  pup_critical_damage: 'Kritische Kraft',
  pup_critical_damage_desc: 'Krit-Schaden +1x/Lv (Basis x3)',

  // Special upgrades - conquest
  special_spy_master: 'Spionagemeister',
  special_spy_master_desc: 'Gesamte Infiltrationskraft x2',

  ad_income_x5: '30min Einkommen',
  ad_income_x5_desc: 'Sieh dir eine Werbung an und erhalte\nsofort {amount} 🛸 (30 Minuten Einkommen)!',
  ad_tap_x10: 'Tippen x10 (10s)',
  ad_tap_x10_desc: 'Sieh dir eine Werbung an und\nverstärke das Tipp-Einkommen 10 Sekunden lang x10!',
  ad_free_docs_desc: 'Sieh dir eine Werbung an und\nerhalte 1 Geheimdokument 📜 kostenlos!',
  ad_prestige_desc: 'Sieh dir eine Werbung an und\nerhöhe dein Einkommen x10 für 15 Sekunden!',
  cq_tutorial_title: '🌍 Weltherrschaft-Anleitung',
  cq_tutorial_text: 'Nach der Eroberung eines Landes kannst du <b>Einrichtungen</b> bauen!\nUpgrade sie für permanente Boni wie\n<b>EPS, Tipp-Einkommen, Offline-Einkommen</b> und mehr.\n\nStelle Agenten ein, um die Infiltrationskraft zu erhöhen.',
  rank_promote: 'Befördern',
  rank_promoted: 'Beförderung abgeschlossen!',
} as const;
